import { Calendar } from '@fullcalendar/core'
import interactionPlugin from '@fullcalendar/interaction'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import esLocale from '@fullcalendar/core/locales/es.js'

require('@fullcalendar/common/main.css')
require('@fullcalendar/daygrid/main.css')
require('@fullcalendar/timegrid/main.css')
require('@fullcalendar/list/main.css')

document.addEventListener('turbolinks:load', () => {
	const calendarEl = document.getElementById('calendar')
	const techniciansSelect = document.getElementById('technician_id')

	function set_events(eventsUrl, currentView = 'dayGridMonth'){

		let calendar = new Calendar(calendarEl, {
			initialView: 'timeGridWeek',
			views: {
				timeGrid: {
					dayHeaderFormat: {
						weekday: 'long',
						day: 'numeric'
					}
				}
			},
			plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
			locale: esLocale,
			headerToolbar: {
				left: 'prev,next today',
				center: 'title',
				right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
			},
			eventTimeFormat: {
				hour: '2-digit', //2-digit, numeric
				minute: '2-digit', //2-digit, numeric
				meridiem: false, //lowercase, short, narrow, false (display of AM/PM)
				hour12: false //true, false
			},
			slotLabelFormat: {
				hour: 'numeric', 
				minute: '2-digit', 
				hour12: false
			},
			selectConstraint: {
				start: new Date(Date.now() - (0.5 * 60 * 60 * 1000))
			},
			allDaySlot: false,
			selectable: true,
			navLinks: true, // can click day/week names to navigate views
			editable: false,
			events: eventsUrl,
			eventClick: function(info) {
				if (info.event.classNames[0] === 'events'){
					var url = '/events/' + info.event.id
				} else {
					var url = '/service_orders/' + info.event.id
				}

				$.getScript(url, function() {
				});
			}
		});

		return calendar
	}

	if (window.location.pathname == '/schedule') {
		let cal = set_events('/schedule.json')
		cal.render()

		techniciansSelect.addEventListener('change', function(e){
			const technicianSelectValue = document.getElementById('technician_id').value
			const eventsUrl = '/schedule.json?tid=' + technicianSelectValue

			const currentView = cal.view.type
			cal.destroy()

			cal = set_events(eventsUrl, currentView)
			cal.render()
		})
	}
});
